import { render, staticRenderFns } from "./AccordionTecnicalData.vue?vue&type=template&id=093e990c&"
import script from "./AccordionTecnicalData.vue?vue&type=script&lang=js&"
export * from "./AccordionTecnicalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports